Controller.$inject = [];

function Controller() {

}

export function HuiCell() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            stickyTop: '@',
            stickyBottom: '@',
            stickyStart: '@',
            stickyEnd: '@',
            as: '@',
            isDisabled: '<',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {

            const tagName = $attrs.as || 'td';

            return `
                <${tagName} ng-class="{
                    'stuck': $huiCtrl.stickyTop || $huiCtrl.stickyBottom || $huiCtrl.stickyStart || $huiCtrl.stickyEnd,
                    'stuck-top': $huiCtrl.stickyTop,
                    'stuck-bottom': $huiCtrl.stickyBottom,
                    'stuck-start': $huiCtrl.stickyStart,
                    'stuck-end': $huiCtrl.stickyEnd,
                    'disabled': $huiCtrl.isDisabled,
                }"
                 ng-style="{
                   top: $huiCtrl.stickyTop,
                   bottom: $huiCtrl.stickyBottom,
                   left: $huiCtrl.stickyStart,
                   right: $huiCtrl.stickyEnd,
                 }"
                 ng-transclude></${tagName}>
            `;
        }
    }
}